import { useEffect } from "react";
import { trackReferral } from "@/utils/analytics";

/**
 * Hook to automatically track referral traffic on component mount
 * Use this in any landing page or key entry point
 */
export function useReferralTracking() {
  useEffect(() => {
    trackReferral();
  }, []);
}
